// Insignia «Virtual» de las citas de telemedicina en la Sala del médico. Las letras hacen una «ola» corta (una pasada y descanso) para que la
// teleconsulta se distinga de las presenciales de un vistazo sin competir con los botones. El texto accesible va UNA vez (sr-only) y las letras
// animadas son decorativas (aria-hidden). Con «reducir movimiento» no hay animación (ver `.ola-virtual` en styles.css).
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export function EtiquetaVirtual(): JSX.Element {
  const { t } = useTranslation();
  const texto = t('sala.marca.virtual');
  return (
    <Badge variant="pine">
      <span className="sr-only">{texto}</span>
      <span aria-hidden="true" className="ola-virtual">
        {Array.from(texto).map((letra, i) => (
          // Posición como clave: el texto es fijo y corto, las letras no se reordenan.
          <span key={i} style={{ animationDelay: `${i * 90}ms` }}>
            {letra === ' ' ? ' ' : letra}
          </span>
        ))}
      </span>
    </Badge>
  );
}
